"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ClickAwayListener = _interopRequireDefault(require("@eig-builder/core-ui/ClickAwayListener"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _portal = _interopRequireDefault(require("@eig-builder/core-utils/portal"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));

var _views = require("./../site-selector-components/views");

var _currentSite = _interopRequireDefault(require("./current-site"));

var _currentDomain = _interopRequireDefault(require("./current-domain"));

var popperModifiers = {
  preventOverflow: {
    enabled: true,
    boundariesElement: 'viewport'
  }
};
var popperOrigin = {
  transformOrigin: 'left top'
};

var BusinessSelectorMenu = function BusinessSelectorMenu(_ref) {
  var children = _ref.children,
      currentBusiness = _ref.currentBusiness;
  var isMobile = (0, _useResponsiveQuery.useIsMobile)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isMenuOpen = _useState2[0],
      setIsMenuOpen = _useState2[1];

  var menuBtnRef = (0, _react.useRef)(null);

  var onMenuClickAway = function onMenuClickAway(e) {
    e.currentTarget.activeElement !== menuBtnRef.current && setIsMenuOpen(false);
  };

  var onMenuBtnClick = function onMenuBtnClick(e) {
    setIsMenuOpen(function (open) {
      return !open;
    });
  };

  var onMenuItemBtnClick = function onMenuItemBtnClick(e) {
    setIsMenuOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_portal["default"], {
    elementId: "header-root"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _runtimeConfigHelper.getRuntimeConfig)()._app,
    style: {
      height: '100%'
    }
  }, currentBusiness.type === 'SITE' ? /*#__PURE__*/_react["default"].createElement(_currentSite["default"], {
    isMobile: isMobile,
    onMenuBtnClick: onMenuBtnClick,
    isMenuOpen: isMenuOpen,
    currentSite: currentBusiness,
    ref: menuBtnRef
  }) : /*#__PURE__*/_react["default"].createElement(_currentDomain["default"], {
    isMobile: isMobile,
    onMenuBtnClick: onMenuBtnClick,
    isMenuOpen: isMenuOpen,
    currentDomain: currentBusiness,
    ref: menuBtnRef
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_views.StyledPopper, {
    isMobile: isMobile,
    open: isMenuOpen,
    anchorEl: menuBtnRef.current,
    placement: "bottom-start",
    modifiers: popperModifiers,
    transition: true
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/_react["default"].createElement(_Grow["default"], (0, _extends2["default"])({}, TransitionProps, {
      id: "navigation-site-selector-menu",
      style: popperOrigin
    }), /*#__PURE__*/_react["default"].createElement(_views.PopperContentContainer, null, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
      onClickAway: onMenuClickAway
    }, /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.map(children, function (child) {
      return _react["default"].cloneElement(child, {
        onMenuItemBtnClick: onMenuItemBtnClick
      });
    })))));
  }))));
};

BusinessSelectorMenu.propTypes = {
  children: _propTypes["default"].node,
  currentBusiness: _propTypes["default"].object
};
var _default = BusinessSelectorMenu;
exports["default"] = _default;